import React, { useState, useEffect, useContext } from 'react';
import DataProvider from '../utils/data-provider';
import ServiceNavigation from './ServiceNavigation.jsx';
import {
  AppLayout,
  BreadcrumbGroup,
  Button,
  ColumnLayout,
  Form,
  FormField,
  Input,
  Multiselect,
  RadioGroup,
  Textarea,
  Tiles,
  Header, Autosuggest, SpaceBetween, Container, Box, TokenGroup,
  TagEditor
} from '@amzn/awsui-components-react/polaris';
import { Auth, Storage } from 'aws-amplify';
import { v4 as uuid } from 'uuid';
import * as debug from '../utils/debug';

import service_list from '../assets/raw/service_list.json';
export class CreateProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toolsIndex: 0, toolsOpen: false, project: { share: 'public', project_name: '', complexity: '100', status: 'created' } };
  }
  componentDidMount() {
    console.log(Storage._config.AWSS3)
    // Storage.list('') // for listing ALL files without prefix, pass '' instead
    // .then(result => console.log(result))
    // .catch(err => console.log(err));
  }

  render() {
    return (
      <AppLayout
        contentType="form"
        navigation={<ServiceNavigation />} // Navigation panel content imported from './ServiceNavigation.jsx'
        breadcrumbs={<BreadcrumbsCreate />}
        content={
          <FormHeader
            // Changes the Help panel content when the user clicks an 'info' link
            // replaceToolsContent={index => this.setState({ toolsIndex: index, toolsOpen: true })}
            project={this.state.project}
            title="Create a project"
          />
        }
        tools={Tools[this.state.toolsIndex]}
        toolsOpen={this.state.toolsOpen}
      />
    );
  }
}

export class UpdateProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toolsIndex: 0, toolsOpen: false, project: [] };
  }
  componentDidMount() {
    new DataProvider().getData('projects', `/${this.props.match.params.project_id}`, {})
      .then(data => {
        debug.log(JSON.stringify(data));
        if (data && data.length == 1) this.setState({ project: data[0] })
      }
      ) // JSON-string from `response.json()` call
      .catch(error => console.error(error));
  }

  render() {
    return (
      <AppLayout
        contentType="form"
        navigation={<ServiceNavigation />} // Navigation panel content imported from './ServiceNavigation.jsx'
        breadcrumbs={<BreadcrumbsUpdate />}
        content={
          <FormHeader
            // Changes the Help panel content when the user clicks an 'info' link
            // replaceToolsContent={index => this.setState({ toolsIndex: index, toolsOpen: true })}
            title="Update a project"
            project={this.state.project}
          />
        }
        tools={Tools[this.state.toolsIndex]}
        toolsOpen={this.state.toolsOpen}
      />
    );
  }
}
// The content in the main content area of the App layout
function FormHeader({ title, project }) {

  const [share, setShare] = useState('public');
  const [project_name, setProject_name] = useState('');
  const [attached_image, setAttached_image] = useState(null);
  const [uploaded_image, setUploaded_image] = useState(null);
  const [complexity, setComplexity] = useState('100');
  const [author, setAuthor] = useState('');
  const [contributors, setContributors] = useState(null);
  const [status, setStatus] = useState('created');
  const [contents_type, setContents_type] = useState([]);
  const [description, setDescription] = useState('');
  const [services, setServices] = useState([]);
  const [link, setLink] = useState([]);
  const [isvalidating, setIsvalidating] = useState(false);
  // const user = useContext(userContext);
  const [user, setUser] = useState();
  const [value, setValue] = React.useState("");
  const [sfdc, setSfdc] = React.useState("");

  useEffect(() => setShare(project.share), [project.share]);
  useEffect(() => setProject_name(project.project_name), [project.project_name]);
  useEffect(() => setAttached_image(project.attached_image), [project.attached_image]);
  useEffect(() => setComplexity(project.complexity), [project.complexity]);
  useEffect(() => setAuthor(project.author), [project.author]);
  useEffect(() => setContributors(project.contributors), [project.contributors]);
  useEffect(() => setStatus(project.status), [project.status]);
  // useEffect(() => setContents_type(project.contents_type), [project.contents_type]);
  useEffect(() => {

    if (typeof project.contents_type === 'string' || project.contents_type instanceof String) {
      //check if a string can be parsed as JSON
      if (/^[\],:{}\s]*$/.test(project.contents_type.replace(/\\["\\\/bfnrtu]/g, '@').
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      }
      else {
        // project.contents_type = [{ label: project.contents_type, value: project.contents_type }];

        let temp_contents_type = [];
        project.contents_type.split(',').forEach(x => { temp_contents_type.push({ value: x, label: x }) })
        project.contents_type = temp_contents_type;
        setContents_type(project.contents_type)
      }
    }
  }, [project.contents_type]);
  //##
  useEffect(() => setDescription(project.description), [project.description]);
  // useEffect(() => setServices(project.services), [project.services]);
  useEffect(() => {

    if (typeof project.services === 'string' || project.services instanceof String) {
      //check if a string can be parsed as JSON
      if (/^[\],:{}\s]*$/.test(project.services.replace(/\\["\\\/bfnrtu]/g, '@').
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      }
      else {
        let temp_services = [];
        project.services.split(',').forEach(x => { temp_services.push({ label: x }) })
        project.services = temp_services;
        setServices(project.services)
      }
    }
  }, [project.services]);

  useEffect(() => setSfdc(project.sfdc), [project.sfdc]);
  useEffect(() => {
    if (typeof project.link === 'string' || project.link instanceof String) {
      if (/^[\],:{}\s]*$/.test(project.link.replace(/\\["\\\/bfnrtu]/g, '@').
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) { project.link = JSON.parse(project.link); }
      else {
        project.link = [{ key: 'ETC', value: project.link }];
        // 
      }
    }
    if (!project.link)
      project.link = [];
    setLink(project.link)
  }, [project.link]);

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(user => {
        if ((!project.author) && (user) && (user.attributes)) {
          setAuthor(user.attributes.email.split("@")[0]);
        }
        setUser(user);
      })
      .catch(err => console.log(err));
  }, []);

  function onclick() {
    setIsvalidating(true);
    if (!project_name || project_name === "") {
      return;
    }
    if (!author || author === "") {
      return;
    }

    let parse_contents_type = Array.isArray(contents_type) ? (contents_type.map(x => x.value)).toString() : contents_type;
    let parse_services = Array.isArray(services) ? (services.map(x => x.label)).toString() : services;
    let parse_link = link;

    let temp = { share, project_name, attached_image, complexity, author, contributors, status, contents_type: parse_contents_type, description, services:parse_services, sfdc, link: JSON.stringify(parse_link) }
    let dataProvider = new DataProvider();
    console.log(temp);
    // return ;
    if (project.project_id) {
      dataProvider.putData('projects', `/${project.project_id}`, temp)
        .then(data => {
          debug.log(JSON.stringify(data));
          window.location.href = '#/projects';
        }
        ) // JSON-string from `response.json()` call
        .catch(error => console.error(error));
    }
    else {
      dataProvider.postData('projects', '', temp)
        .then(data => {
          debug.log(JSON.stringify(data));
          window.location.href = '#/projects';
        }
        ) // JSON-string from `response.json()` call
        .catch(error => console.error(error));
    }
  }

  return (
    <div>
      <Form
        header={
          <Header
            variant="h1"
          // info={<InfoLink id="form-main-info-link" onFollow={() => updateTools(0)} />}
          // description="When you create an Amazon CloudFront distribution, you tell CloudFront where to find your content by specifying your origin servers."
          >
            {title}
          </Header>
        }
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" href="#/projects">
              Cancel
        </Button>
            <Button variant="primary" onClick={onclick} >{title}</Button>
          </SpaceBetween>
        }
      >
        <SpaceBetween direction="vertical" size="l">
          <Container
            header={<Header variant="h2">Basic information</Header>}
          >
            <SpaceBetween direction="vertical" size="xl">
              <FormField
                label={
                  <span id="delivery-method-label">
                    Project Name
              <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={true}
                errorText={isvalidating && !project_name ? "Project name is required." : ""}
              >
                <Input
                  value={project_name}
                  placeholder="Enter Project Name"
                  onChange={event =>
                    setProject_name(event.detail.value)
                  }
                  invalid={isvalidating && !project_name}
                />
              </FormField>
              <FormField
                label={
                  <span id="delivery-method-label">
                    Access control
              <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={true}
              >
                <Tiles
                  items={[
                    {
                      value: 'public',
                      label: 'Public',
                      description: 'This project is a public asset that can be shared with customers.'
                    },
                    {
                      value: 'private',
                      label: 'Private',
                      description:
                        'This project is currently being worked on and is accessible only to project members.'
                    },
                    {
                      value: 'internal',
                      label: 'Internal',
                      description:
                        'This project is restricted to direct sharing to customers or for internal use.'
                    }
                  ]}
                  value={share}
                  onChange={e =>
                    setShare(e.detail.value)
                  }
                />
              </FormField>
              <FormField
                label={
                  <span id="delivery-method-label">
                    Description
              <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={true}
              >
                <Textarea
                  onChange={({ detail }) => setDescription(detail.value)}
                  value={description}
                  rows={10}
                  placeholder="Please explain about this demo details."
                />
              </FormField>

              <FormField
                label={
                  <span id="delivery-method-label">
                    Image (URL)
                    <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={true}
              >
                <Input
                  value={attached_image}
                  placeholder="Please attach an image that describes the project well."
                  onChange={event =>
                    setAttached_image(event.detail.value)
                  }
                  disabled={uploaded_image}
                /> or <S3ImageUpload setUploaded_image={setUploaded_image} setAttached_image={setAttached_image}></S3ImageUpload>
              </FormField>
              <ColumnLayout columns={2}>
                <FormField
                  label={
                    <span id="delivery-method-label">
                      Complexity
                    <Box variant="span" margin={{ left: 'xs' }}>
                        {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                      </Box>
                    </span>
                  }
                  stretch={true}
                >
                  <RadioGroup
                    onChange={({ detail }) => setComplexity(detail.value)}
                    value={complexity}
                    items={[
                      { value: "100", label: "100 Level" },
                      { value: "200", label: "200 Level" },
                      { value: "300", label: "300 Level" },
                      { value: "400", label: "400 Level" }

                    ]}
                  />
                </FormField>
                <FormField
                  label={
                    <span id="delivery-method-label">
                      Project progress
                    <Box variant="span" margin={{ left: 'xs' }}>
                        {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                      </Box>
                    </span>
                  }
                  stretch={true}
                >
                  <RadioGroup
                    onChange={({ detail }) => setStatus(detail.value)}
                    value={status}
                    items={[
                      { value: "created", label: "Created" },
                      { value: "ongoing", label: "Ongoing" },
                      { value: "completed", label: "Completed" }
                    ]}
                  />
                </FormField>

              </ColumnLayout>
              <FormField
                label={
                  <span id="delivery-method-label">
                    Related AWS Services
                    <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={false}
                secondaryControl={
                  <Button onClick=
                  {() => {
                    var isExist = (services && services.filter(i => i.label === value).length > 0) ? true : false;
                    debug.log(services);
                    debug.log(value);
                    if ((value.length > 0) && !(isExist))
                      setServices([...services, { "label": value }]);
                      setValue("");
                  }
                  } variant="normal"> Add </Button>
                }

              >
                <Autosuggest
                  onChange={({ detail }) => setValue(detail.value)}
                  value={value}
                  placeholder="Enter related AWS services "
                  options={service_list}
                  enteredTextLabel={value => `Use: "${value}"`}
                  ariaLabel="Autosuggest example with suggestions"
                  placeholder="Select or enter a service name then click 'Add' button."
                  empty="No matches found"
                />
                <TokenGroup
                  onDismiss={({ detail: { itemIndex } }) => {
                    setServices([
                      ...services.slice(0, itemIndex),
                      ...services.slice(itemIndex + 1)
                    ]);
                  }}
                  items={services}
                />
                {/* <Input
                  value={services}
                  placeholder="Enter related AWS services separated by commas."
                  onChange={event =>
                    setServices(event.detail.value)
                  }
                /> */}
              </FormField>
              <FormField
                label={
                  <span id="delivery-method-label">
                    Content Type
                    <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={true}
              >
                <Multiselect
                  selectedOptions={contents_type}
                  onChange={({ detail }) =>
                    setContents_type(detail.selectedOptions)
                  }
                  deselectAriaLabel={e => "Remove " + e.label}
                  options={[
                    { label: "Hands-on", value: "HoL" },
                    {
                      label: "Live Demo Site",
                      value: "Live Demo Site"
                    },
                    { label: "Workshop", value: "Workshop" },
                    { label: "Video", value: "Video" },
                    { label: "Etc", value: "Etc" }
                  ]}
                  placeholder="Choose options"
                  selectedAriaLabel="Selected"
                />
              </FormField>
              <FormField
                label={
                  <span id="delivery-method-label">
                    SFDC Campaign Code (Optional)
                    {/* <Box variant="span" margin={{ left: 'xs' }}>
                      <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} />
                    </Box> */}
                    
                  </span>
                }
                stretch={true}
              >
                <small>Optionally if you want to track related opportunities based on the SFDC campaign code. (Currently, an individual must request and be issued a code.)</small>
                <Input
                  value={sfdc}
                  placeholder="Enter a SFDC Campaign code"
                  onChange={event =>
                    setSfdc(event.detail.value)
                  }
                />
              </FormField>
            </SpaceBetween>
          </Container>

          <Container
            header={<Header variant="h2">Project team</Header>}
          >

            <ColumnLayout columns={2}>
              <FormField
                label={
                  <span id="delivery-method-label">
                    Writer (email alias without @)
                    <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={true}
                errorText={isvalidating && !author ? "Writer is required." : ""}
              >
                <Input
                  value={author}
                  placeholder="Enter an email alias."
                  onChange={event =>
                    setAuthor(event.detail.value)
                  }
                  invalid={isvalidating && !author}
                  disableBrowserAutocorrect
                  autoComplete={false}
                />
              </FormField>
              <FormField
                label={
                  <span id="delivery-method-label">
                    Contributors
                    <Box variant="span" margin={{ left: 'xs' }}>
                      {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                    </Box>
                  </span>
                }
                stretch={true}
              >
                <Input
                  value={contributors}
                  placeholder="Enter email aliases separated by commas."
                  onChange={event =>
                    setContributors(event.detail.value)
                  }
                  disableBrowserAutocorrect
                  autoComplete={false}
                />
              </FormField>
            </ColumnLayout>

          </Container>
          <Container

            header={<Header variant="h2">Resources</Header>}
          >
            <FormField
              label={
                <span id="delivery-method-label">
                  Project assets
              <Box variant="span" margin={{ left: 'xs' }}>
                    {/* <InfoLink id="delivery-method-info-link" onFollow={() => this.props.updateTools(1)} /> */}
                  </Box>
                </span>
              }
              stretch={true}
            >
              <TagEditor
                allowedCharacterPattern=""
                i18nStrings={{
                  keyPlaceholder: "Enter resource type",
                  valuePlaceholder: "Enter resource location",
                  addButton: "Add new link",
                  removeButton: "Remove",
                  undoButton: "Undo",
                  undoPrompt:
                    "This tag will be removed upon saving changes",
                  loading:
                    "Loading tags that are associated with this resource",
                  keyHeader: "Resource type",
                  valueHeader: "Resource location",
                  keySuggestion: "Custom tag key",
                  valueSuggestion: "Custom tag value",
                  emptyTags:
                    "No link associated with the resource.",
                  tooManyKeysSuggestion:
                    "You have more keys than can be displayed",
                  tooManyValuesSuggestion:
                    "You have more values than can be displayed",
                  keysSuggestionLoading: "Loading tag keys",
                  keysSuggestionError:
                    "Tag keys could not be retrieved",
                  valuesSuggestionLoading: "Loading tag values",
                  valuesSuggestionError:
                    "Tag values could not be retrieved",
                  emptyKeyError: "You must specify a tag key",
                  maxKeyCharLengthError:
                    "The maximum number of characters you can use in a tag key is 128.",
                  maxValueCharLengthError:
                    "The maximum number of characters you can use in a tag value is 256.",

                  tagLimit: availableTags =>
                    availableTags === 1
                      ? "You can add 1 more link."
                      : "You can add " +
                      availableTags +
                      " more links.",
                  tagLimitReached: tagLimit =>
                    tagLimit === 1
                      ? "You have reached the limit of 1 links."
                      : "You have reached the limit of " +
                      tagLimit +
                      " links.",
                  tagLimitExceeded: tagLimit =>
                    tagLimit === 1
                      ? "You have exceeded the limit of 1 links."
                      : "You have exceeded the limit of " +
                      tagLimit +
                      " links.",
                  enteredKeyLabel: key => 'Use "' + key + '"',
                  enteredValueLabel: value => 'Use "' + value + '"'
                }}
                tags={link}
                onChange={({ detail }) => setLink(detail.tags)}
                keysRequest={() =>
                  Promise.resolve([
                    "Source (Github)",
                    "Source (Other)",
                    "Live demo page",
                    "Workshop page",
                    "Workshop (Source)",
                    "Video",
                    "Hands-on Material",
                    "ETC"
                  ])
                }
                valuesRequest={(key, value) =>
                  key
                    ? Promise.resolve(["http://", "https://"])
                    : Promise.reject()
                }
              // tagLimit={10}
              />
            </FormField>
          </Container>
        </SpaceBetween>
      </Form>
    </div>
  );
}

class S3ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = { uploading: false }
    this.uploadFile.bind(this)

  }

  uploadFile = async (file) => {
    const fileName = uuid();
    const result = await Storage.put(
      fileName + "-" + file.name,
      file,
      {
        level: 'public'
      }
    );

    this.props.setUploaded_image(`S3://${Storage._config.AWSS3.bucket}/public/${fileName + "-" + file.name}`)
    this.props.setAttached_image(`S3://${Storage._config.AWSS3.bucket}/public/${fileName + "-" + file.name}`)
    console.log('Uploaded file: ', result);

  }

  onChange = async (e) => {
    this.setState({ uploading: true });

    let files = [];
    for (var i = 0; i < e.target.files.length; i++) {
      files.push(e.target.files.item(i));
    }
    await Promise.all(files.map(f => this.uploadFile(f)));

    this.setState({ uploading: false });
  }

  render() {
    return (
      <div>

        <Button
          onClick={() => document.getElementById('add-image-file-input').click()}
          disabled={this.state.uploading}
          icon='file image outline'
          content={this.state.uploading ? 'Uploading...' : 'Add Images'}
        >{this.state.uploading ? 'Uploading...' : 'Choose local file'}</Button>

        <input
          id='add-image-file-input'
          type="file"
          accept='image/*'
          onChange={this.onChange}
          style={{ display: 'none' }}
        />
      </div>
    );
  }
}

// Breadcrumb content
const BreadcrumbsCreate = () => (
  <BreadcrumbGroup
    items={[
      {
        text: 'Home',
        href: '#/'
      },
      {
        text: 'Projects',
        href: '#/projects'
      },
      {
        text: 'Create a Project',
        href: '#/projects/create'
      }
    ]}
  />
);
const BreadcrumbsUpdate = () => (
  <BreadcrumbGroup
    items={[
      {
        text: 'Home',
        href: '#/'
      },
      {
        text: 'Projects',
        href: '#/projects'
      },
      {
        text: 'Update a Project',
        href: '#/projects/update'
      }
    ]}
  />
);

// List of Help (right) panel content, changes depending on which 'info' link the user clicks on.
const Tools = [
  <div ></div>
];
